// tracking URL param for the ActionKit CRM
export const URL_KEY_AKID = 'akid'
// tracking URL param for the Action Network CRM
export const URL_KEY_EMAIL_REFERRER = 'email_referrer'
// Agra uses this to pass partner hints to event creation.
export const URL_KEY_PARTNER = 'partner'
export const URL_KEY_SOURCE = 'source'
// generic UTM codes
export const URL_KEY_UTM_CAMPAIGN = 'utm_campaign'
export const URL_KEY_UTM_CONTENT = 'utm_content'
export const URL_KEY_UTM_MEDIUM = 'utm_medium'
export const URL_KEY_UTM_SOURCE = 'utm_source'
export const URL_KEY_UTM_TERM = 'utm_term'
// tracking URL param for the EveryAction CRM
export const URL_KEY_SOURCE_ID = 'sourceid'

export const TRACKING_URL_PARAMS = [URL_KEY_AKID, URL_KEY_EMAIL_REFERRER, URL_KEY_SOURCE,
                                    URL_KEY_SOURCE_ID, URL_KEY_UTM_CAMPAIGN, URL_KEY_UTM_CONTENT,
                                    URL_KEY_UTM_MEDIUM, URL_KEY_UTM_SOURCE,
                                    URL_KEY_UTM_TERM]
